import React, { Suspense } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { initializeApp } from 'firebase/app';
import { createRoot } from 'react-dom/client';
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/pt-br';

import App from './App';
import { SRP_AUTH_FLOW, SRP_AUTH_FLOW_NO_OAUTH } from './config/amplify';
import './config/chartjs';
import './shared/translations/i18n';
import LoadingPage from './shared/components/LoadingPage/LoadingPage';
import { AUTH_ROUTES } from './shared/constants/auth';
import { FIREBASE_CONFIG } from './shared/constants/firebase';
import TagManagerService from './shared/services/gtm/tagManagerService';

import './index.scss';

TagManagerService.initialize();
if (AUTH_ROUTES.includes(window.location.pathname)) {
  SRP_AUTH_FLOW();
} else {
  SRP_AUTH_FLOW_NO_OAUTH();
}
initializeApp(FIREBASE_CONFIG);

datadogRum.init({
  applicationId: '872314df-e8bc-4e62-a4da-5a044d4c1164',
  clientToken: 'pub7b0e85dba09bd09ac7c9a252d269aa5b',
  site: 'datadoghq.com',
  service: 'clients-portal',
  env: process.env.VITE_ENV_SHORTNAME,
  version: '6.18.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  defaultPrivacyLevel: 'mask-user-input'
});

const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.VITE_RECAPTCHA_SITE_KEY}`;
document.head.appendChild(script);

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingPage />}>
      <App />
    </Suspense>
  </React.StrictMode>
);
